import { render, staticRenderFns } from "./toolStopRegistAction.vue?vue&type=template&id=2b8aadcc&scoped=true"
import script from "./toolStopRegistAction.vue?vue&type=script&lang=js"
export * from "./toolStopRegistAction.vue?vue&type=script&lang=js"
import style0 from "./toolStopRegistAction.vue?vue&type=style&index=0&id=2b8aadcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8aadcc",
  null
  
)

export default component.exports